import { useState } from "react";
import { Card, Input, Modal, notification, Button } from "antd";
import { marcarCarnetParticipante } from "../../api/sistema";
import { useAuth } from "../../utils/useAuth";
import RParticipante from "../../components/Responder/RParticipante";

const { Search } = Input;

function CarnetParticipante() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [isConsulting, setIsConsulting] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const { usuario } = useAuth();

  const handleSearch = (value) => {
    if (!value.length) return null;

    setIsConsulting(true);

    const body = {
      dniregistrador: usuario.nrodocumento || "not found",
      codigoOrDNI: value
    };

    marcarCarnetParticipante(body)
      .then((res) => {
        setIsModalVisible(true);
        setModalContent(<RParticipante response={res.payload} type="carnet" />);
      })
      .catch((err) => {
        notification.error({ description: err.message });
      })
      .finally(() => {
        setIsConsulting(false);
      });
    setSearchValue("");
  };

  return (
    <div className="p-4 mx-auto text-center w-full">
      <div className="w-full">
        <Card className="mt-8 px-2 rounded-lg max-w-sm mx-auto">
          <div className="font-semibold flex flex-col">
            <span className="mb-2 text-base">
              Marcar entrega de carnet por correlativo ó DNI de{" "}
              <span className="text-blue-500 font-bold">PARTICIPANTE</span>
            </span>
            <Search
              placeholder="ejem. 120010"
              className="text-2xl"
              type="number"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onSearch={handleSearch}
              enterButton
              loading={isConsulting}
              allowClear
              size="large"
            />
          </div>
        </Card>
        
        <div className="my-10" style={{ height: '40px' }}></div>
      </div>

      <Modal
        visible={isModalVisible}
        closable
        onCancel={() => setIsModalVisible(false)}
        destroyOnClose
        footer={
          <Button onClick={() => setIsModalVisible(false)} block type="primary">
            Cerrar
          </Button>
        }
        maskClosable={false}
      >
        {modalContent}
      </Modal>
    </div>
  );
}

export default CarnetParticipante;
